import {Notification} from '../Notification/Notification';
import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import classNames from 'classnames';

const NotificationsContainer = () => {
	const notifications = useSelector(state => state.appNotifications.notifications);
	const leftRailOpen = useSelector(state => state.uistore.leftRailOpen);

	const [notificationsPresent, setNotificationsPresent] = useState((notifications.length > 0));

	useEffect(() => {
		setNotificationsPresent((notifications.length > 0));
	}, [notifications]);

	return (
		<div className={classNames('notification-module-adjustment', {'left-nav-open': leftRailOpen, 'notifications-present': notificationsPresent})}>
			{notifications.map((notification, key) => (
				<Notification
					key={key}
					name={notification.name}
					isOpen={notification.isOpen}
					className={notification.className}
					variant={notification.variant}
					actionLabel={notification.actionLabel}
					text={notification.text}
					closeOnAction={notification.closeOnAction}
					closable={notification.closable}
					onActionCallback={notification.onActionCallback}
					onCloseCallback={notification.onCloseCallback}
				/>
			))}
		</div>
	);
};

export default NotificationsContainer;
